import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  font-weight: 500;\n'], ['\n  font-weight: 500;\n']);

import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { styles, utils, translations } from 'gipsy-misc';
import { tags as tagsApi } from 'gipsy-api';
import { Tag, AddTagButton } from '../../..';

import CreatableSelect from 'react-select/creatable';

var AddTagForm = function (_PureComponent) {
  _inherits(AddTagForm, _PureComponent);

  function AddTagForm(props) {
    var _this2 = this;

    _classCallCheck(this, AddTagForm);

    var _this = _possibleConstructorReturn(this, (AddTagForm.__proto__ || Object.getPrototypeOf(AddTagForm)).call(this, props));

    _this.onFocus = function () {
      _this.setState({ focus: true });
    };

    _this.onKeyDown = function (e) {
      if (e.keyCode === 27) {
        _this.onBlur();
      }
    };

    _this.filterOption = function (option, currentValue) {
      if (option.data.__isNew__) {
        return true;
      }
      var tagName = option.value.name;
      return tagName.toLowerCase().includes(currentValue.toLowerCase()) && utils.array.getObjectIndexInArray(_this.props.taskTags, option.value, ['id']) === -1;
    };

    _this.makeOptions = function (tags) {
      return tags && tags.map(function (tag) {
        return { value: tag, label: tag.name };
      }) || [];
    };

    _this.onBlur = function () {
      _this.setState({
        focus: false
      });
      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    };

    _this.componentDidMount = function () {
      _this.fetch();
    };

    _this.fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var allTags;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return tagsApi.get();

            case 3:
              allTags = _context.sent;

              _this.setState({ allTags: allTags });
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 7]]);
    }));

    _this.formatOptions = function (option) {
      if (option.__isNew__) {
        return React.createElement(
          Fragment,
          null,
          React.createElement(
            CreateTagOption,
            null,
            translations.taskPanel.tags.createTagLabel
          ),
          option.label
        );
      }

      var tag = option.value;
      return React.createElement(Tag, {
        id: tag.id,
        name: tag.name,
        color: tag.color,
        onFocus: _this.onFocus,
        backgroundColor: tag.backgroundColor,
        mode: 'preview'
      });
    };

    _this.formatCreateLabel = function (inputValue) {
      return inputValue;
    };

    _this.onSelect = function (option) {
      _this.props.onSelect(option.value);
      _this.onBlur();
    };

    _this.onCreateOption = function (optionValue) {
      _this.props.onCreateOption(optionValue);
      _this.onBlur();
    };

    _this.state = {
      focus: true,
      allTags: [],
      newTagName: ''
    };
    return _this;
  }

  _createClass(AddTagForm, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          focus = _state.focus,
          allTags = _state.allTags;


      var options = this.makeOptions(allTags);

      return React.createElement(
        Fragment,
        null,
        focus && React.createElement(CreatableSelect, {
          openMenuOnFocus: true,
          tabSelectsValue: false,
          options: options,
          filterOption: this.filterOption,
          formatOptionLabel: this.formatOptions,
          formatCreateLabel: this.formatCreateLabel,
          placeholder: translations.taskPanel.tags.findTagPlaceholder,
          autoFocus: true,
          components: {
            DropdownIndicator: function DropdownIndicator() {
              return null;
            },
            IndicatorSeparator: function IndicatorSeparator() {
              return null;
            }
          },
          styles: {
            container: function container(base) {
              return _extends({}, base, {
                display: 'inline-block'
              });
            },
            control: function control(base) {
              return _extends({}, base, {
                backgroundColor: styles.colors.buttonLightColor,
                borderRadius: '18px',
                border: 'none',
                boxShadow: 'none',
                width: '288px'
              });
            },
            placeholder: function placeholder(base) {
              return _extends({}, base, {
                font: styles.fonts.primaryFont,
                fontSize: styles.fonts.fontSizeSmall,
                paddingLeft: '2px'
              });
            }
          },
          onKeyDown: this.onKeyDown,
          onChange: this.onSelect,
          onCreateOption: this.onCreateOption,
          onBlur: this.onBlur
        })
      );
    }
  }]);

  return AddTagForm;
}(PureComponent);

var CreateTagOption = styled.span(_templateObject);

export default AddTagForm;
//# sourceMappingURL=AddTagForm.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/Tags/AddTagForm.js
// module id = 1115
// module chunks = 0